/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createTypeOf } from '../../factoriesAny.js';
export var typeOfDependencies = {
  typedDependencies: typedDependencies,
  createTypeOf: createTypeOf
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesTypeOf.generated.js
// module id = 1537
// module chunks = 0